import {Switch, Route, useRouteMatch} from 'react-router-dom';
import EditCustomer from './Edit';
import ShowCustomer from './Show';
import Customers from './Main';
import ApproveCustomers from './Approve';
import CreateLocation from '../locations/Create';
import {Checkbox, LegacyStack} from "@shopify/polaris";

export function getBusinessTypeName(type)
{
    if (type == 'retail_store') return "Retail Store";
    if (type == 'online_retailer') return "Online Retailer";
    if (type == 'service_maintenance_business') return "Service Maintenance Business";
    if (type == 'educational_institution') return "Educational Institution";
    if (type == 'public_aquarium_zoo') return "Public Aquarium/Zoo";

    return '';
}

export function getFileName(type)
{
    if (type == 'state_sales_tax_resale_file') return "State Sales Tax Resale #";
    if (type == 'business_license_file') return "Business License or Federal Tax ID";
    if (type == 'proof_1_file') return "Proof 1";
    if (type == 'proof_2_file') return "Proof 2";
    if (type == 'proof_3_file') return "Proof 3";
    if (type == 'proof_4_file') return "Proof 4";

    return '';
}

export default () => {
    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route exact path={path}><Customers /></Route>
            <Route path={`${path}/approve`}><ApproveCustomers /></Route>
            <Route path={`${path}/:customerId/edit`}><EditCustomer /></Route>
            <Route exact path={`${path}/:customerId`}><ShowCustomer /></Route>
            <Route path={`${path}/:customerId/locations/create`}><CreateLocation /></Route>
        </Switch>
    )
}
